module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-living-0ddfa3d4.jpg";